<template>
  <div class="account-right fixed-mp-cls">
    <orders-bread-crumb></orders-bread-crumb>
    <div class="account-card group-tab">
      <orders-account-header></orders-account-header>
      <order-tabs></order-tabs>
      <div class="account-body">
        <div
          id="schedule"
          class="tab-pane fade"
          :class="{
            'active show': $route.name === 'profile.scheduled-orders',
          }"
        >
          <div class="order-lists d-sm-block" v-if="orders && orders.length">
            <order
              v-for="(order, index) in orders"
              :key="index"
              :isScheduled="true"
              :order="order"
            />
          </div>
          <div v-else class="order-lists">
            <h5 class="nothing-found">{{ _T('No Scheduled Orders Found') }}</h5>
          </div>
          <!-- <mobile-scheduled-orders /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrdersBreadCrumb from './OrdersBreadCrumb'
import OrderTabs from './OrderTabs'
import Order from './Order'
import OrdersAccountHeader from './OrdersAccountHeader'
// import MobileScheduledOrders from './MobileScheduledOrders'
import { mapGetters } from 'vuex'
export default {
  name: 'ScheduledOrders',
  components: {
    OrdersBreadCrumb,
    OrderTabs,
    Order,
    OrdersAccountHeader,
    // MobileScheduledOrders,
  },
  computed: {
    ...mapGetters(['all_customer_orders', '_T']),
    orders() {
      if (this.all_customer_orders) {
        let filteredOrders = this.all_customer_orders.filter(
          order => order.future_order_datetime !== ''
        )
        return filteredOrders ? filteredOrders : []
      }
      return []
    },
  },
}
</script>

<style lang="scss" scoped>
.account-card {
  box-shadow: 0px 4px 34px rgba($black, 0.07);
  margin: $px18 0 $px30;
  border-radius: $px10;
  &.group-tab {
    position: relative;
  }
}
.order-lists {
  padding: $px30;
  overflow: hidden;
  max-height: $px500;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .nothing-found {
    font-weight: bold;
  }
}
@media (max-width: 1199px) {
  .order-lists {
    padding: $px20;
  }
}
@media (max-width: 991px) {
  .order-lists {
    padding: $px20 $px10;
  }
}
@media (max-width: 575px) {
  .account-card {
    margin: 0;
  }
  .order-lists {
    max-height: 100%;
  }
}
</style>
